import React from "react";
import { claimApi } from "@/main/api";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { ClaimSearchRequest } from "@/main/models/request";
import { ClaimSearchGridResponse } from "@/main/models/response";
import RowSearchClaim from "./rowSearchClaim/rowSearchClaim";
import * as S from "./styles";

interface IGridSearchClaimProps {
	dataGrid: ClaimSearchGridResponse[];
	formFilters: ClaimSearchRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<any[]>>;
	refreshClaimCounts: () => void;
}

function GridSearchClaim({ dataGrid, formFilters, setDataGrid, refreshClaimCounts }: IGridSearchClaimProps) {
	async function fetchData(request: any) {
		return claimApi.searchGrid(request).then((response) => response.data);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				fetchEqualFilters
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchData}
			>
				<S.ContainerRow>
					{dataGrid.map((item, index) => (
						<RowSearchClaim
							key={item.guidClaim}
							searchClaim={item}
							index={index}
							refreshClaimCounts={refreshClaimCounts}
						/>
					))}
				</S.ContainerRow>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridSearchClaim;
